export default "__VITE_ASSET__BvLXKD99__"